import { PlusOutlined, MinusOutlined, DeleteOutlined } from '@ant-design/icons';
import ImagenNoDisp from "../../../assets/imagen-no-disponible.jpeg";
import { useClient } from "../../../context/ClientContext";

export const CardItemMobile = ({ producto, onUpdate, onDelete, promoLabel }) => {
  const { theme } = useClient();
  const primary = theme.primaryColor || '#111827';
  const precioFinal = producto?.promo?.precio_final ?? null;
  const precioUnit = precioFinal ?? producto?.precio_unit ?? 0;
  const subtotal = precioUnit * (producto?.cantidad || 0);

  return (
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      <div style={{
        width: 64, height: 64, borderRadius: 8, overflow: "hidden", flexShrink: 0,
        background: "#f5f5f7", display: "flex", alignItems: "center", justifyContent: "center",
        position: "relative",
      }}>
        <img
          src={producto?.imagen || ImagenNoDisp}
          alt={producto?.producto}
          style={{ width: "100%", height: "100%", objectFit: "contain", padding: 6 }}
          onError={e => { e.target.src = ImagenNoDisp; }}
        />
        {promoLabel && (
          <div style={{
            position: "absolute", top: 3, left: 3,
            background: "#e53e3e", color: "#fff",
            fontSize: 8, fontWeight: 700, padding: "1px 4px",
            borderRadius: 3, lineHeight: 1.2,
          }}>
            {promoLabel}
          </div>
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111827", marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {producto?.producto}
        </div>
        {producto?.codigo && (
          <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 6 }}>CÓD. {producto.codigo}</div>
        )}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 0, border: "1.5px solid #e5e7eb", borderRadius: 6, overflow: "hidden" }}>
            <button
              onClick={() => producto.cantidad > 1 && onUpdate(-1)}
              disabled={producto.cantidad <= 1}
              style={{
                width: 28, height: 28, border: "none", background: "transparent",
                cursor: producto.cantidad <= 1 ? "not-allowed" : "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: producto.cantidad <= 1 ? "#d1d5db" : "#374151", fontSize: 12,
              }}
            >
              <MinusOutlined />
            </button>
            <span style={{ width: 26, textAlign: "center", fontSize: 13, fontWeight: 600, color: "#111827" }}>
              {producto.cantidad}
            </span>
            <button
              onClick={() => onUpdate(1)}
              style={{
                width: 28, height: 28, border: "none", background: "transparent",
                cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                color: "#374151", fontSize: 12,
              }}
            >
              <PlusOutlined />
            </button>
          </div>
          <div style={{ textAlign: "right" }}>
            {precioFinal != null && (
              <div style={{ fontSize: 10, color: "#9ca3af", textDecoration: "line-through" }}>
                ${((producto?.precio_unit || 0) * (producto?.cantidad || 0)).toFixed(2)}
              </div>
            )}
            <div style={{ fontSize: 15, fontWeight: 700, color: precioFinal != null ? "#e53e3e" : primary }}>
              ${subtotal.toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={onDelete}
        style={{
          width: 28, height: 28, border: "1px solid #fca5a5", borderRadius: "50%",
          background: "#fff", cursor: "pointer", flexShrink: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#ef4444", fontSize: 12,
        }}
      >
        <DeleteOutlined />
      </button>
    </div>
  );
}
